import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from './assets/logo.png';

function PrivacyPolicy() {
  const [scrolled, setScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    let scrollTimer;
    const onScroll = () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => setScrolled(window.scrollY > 50), 16);
    };

    const onResize = () => setIsMobile(window.innerWidth <= 768);

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });

    return () => {
      clearTimeout(scrollTimer);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(to bottom, #0F1419, #1A1F2E)',
      color: '#E8E8E8',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      {/* Navigation */}
      <nav 
        role="navigation"
        aria-label="Main navigation"
        style={{
          position: 'fixed',
          width: '100%',
          top: 0,
          zIndex: 1000,
          transition: 'all 0.3s ease',
          background: scrolled ? 'rgba(15, 20, 25, 0.95)' : 'rgba(15, 20, 25, 0.8)',
          backdropFilter: 'blur(20px)',
          borderBottom: '1px solid rgba(199, 179, 129, 0.1)'
        }}
      >
        <div style={{ 
          maxWidth: '1800px', 
          margin: '0 auto', 
          padding: 'clamp(1rem, 2vw, 1.5rem) clamp(1.5rem, 4vw, 3rem)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <Link 
            to="/" 
            aria-label="ST Motors Home"
            style={{ 
              textDecoration: 'none', 
              display: 'flex', 
              alignItems: 'center', 
              gap: 'clamp(0.75rem, 2vw, 1rem)'
            }}
          >
            <img 
              src={logo} 
              alt="ST Motors Logo" 
              style={{ height: 'clamp(40px, 6vw, 55px)', width: 'auto' }}
            />
            <div style={{
              fontSize: 'clamp(1.1rem, 2.2vw, 1.5rem)',
              fontWeight: '700',
              color: '#FFFFFF',
              letterSpacing: '0.02em'
            }}>
              ST MOTORS
            </div>
          </Link>

          <Link
            to="/"
            style={{
              padding: 'clamp(0.6rem, 1.2vw, 0.75rem) clamp(1rem, 2vw, 1.5rem)',
              borderRadius: '8px',
              color: '#C7B381',
              textDecoration: 'none',
              fontSize: 'clamp(0.8rem, 1.4vw, 0.9rem)',
              fontWeight: '500',
              transition: 'all 0.3s ease',
              border: '1px solid rgba(199, 179, 129, 0.3)'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.background = 'rgba(199, 179, 129, 0.15)';
              e.currentTarget.style.borderColor = 'rgba(199, 179, 129, 0.4)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.borderColor = 'rgba(199, 179, 129, 0.3)';
            }}
          >
            ← Back to Home
          </Link>
        </div>
      </nav>

      {/* Content */}
      <main style={{
        maxWidth: '900px',
        margin: '0 auto',
        padding: 'clamp(8rem, 12vw, 10rem) clamp(1.5rem, 4vw, 2rem) clamp(4rem, 8vw, 6rem)',
        position: 'relative'
      }}>
        {/* Decorative background */}
        <div style={{
          position: 'absolute',
          top: '20%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '600px',
          height: '600px',
          background: 'radial-gradient(circle, rgba(199, 179, 129, 0.08) 0%, transparent 70%)',
          pointerEvents: 'none',
          zIndex: 0
        }}></div>

        <div style={{ position: 'relative', zIndex: 1 }}>
          {/* Header */}
          <div style={{ textAlign: 'center', marginBottom: 'clamp(3rem, 6vw, 5rem)' }}>
            <div style={{
              display: 'inline-block',
              padding: '0.5rem 1.25rem',
              borderRadius: '30px',
              fontSize: 'clamp(0.7rem, 1.4vw, 0.8rem)',
              fontWeight: '600',
              letterSpacing: '0.15em',
              textTransform: 'uppercase',
              marginBottom: 'clamp(1.5rem, 3vw, 2rem)'
            }}>
              Legal Information
            </div>

            <h1 style={{
              fontSize: 'clamp(2.5rem, 6vw, 4rem)',
              fontWeight: '300',
              marginBottom: 'clamp(1rem, 2vw, 1.5rem)',
              color: '#FFFFFF',
              letterSpacing: '-0.02em'
            }}>
              Privacy <span style={{ fontWeight: '600', color: '#C7B381' }}>Policy</span>
            </h1>

            <div style={{
              width: 'clamp(60px, 10vw, 80px)',
              height: '2px',
              background: 'linear-gradient(90deg, transparent, #C7B381, transparent)',
              margin: '0 auto'
            }}></div>
          </div>

          {/* Content Card */}
          <div style={{
            background: 'rgba(15, 20, 25, 0.6)',
            border: '1px solid rgba(199, 179, 129, 0.15)',
            borderRadius: '16px',
            padding: 'clamp(2rem, 5vw, 3.5rem)',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
          }}>
            <div style={{
              fontSize: 'clamp(1rem, 2vw, 1.15rem)',
              lineHeight: '1.8',
              color: '#B8B8B8',
              fontWeight: '300'
            }}>
              <p style={{ marginBottom: '1.5rem' }}>
                ST Motors respects your privacy and is committed to transparency in how we handle information.
              </p>

              <h2 style={{
                fontSize: 'clamp(1.3rem, 2.5vw, 1.6rem)',
                fontWeight: '500',
                color: '#C7B381',
                marginTop: 'clamp(2rem, 4vw, 3rem)',
                marginBottom: '1rem',
                letterSpacing: '0.02em'
              }}>
                Information Collection
              </h2>
              <p style={{ marginBottom: '1.5rem' }}>
                ST Motors <strong style={{ color: '#E8E8E8' }}>does not collect personal information</strong> from visitors to this website. 
                This site is intended only to display vehicle images, specifications, and pricing.
              </p>

              <h2 style={{
                fontSize: 'clamp(1.3rem, 2.5vw, 1.6rem)',
                fontWeight: '500',
                color: '#C7B381',
                marginTop: 'clamp(2rem, 4vw, 3rem)',
                marginBottom: '1rem',
                letterSpacing: '0.02em'
              }}>
                Technical Data
              </h2>
              <p style={{ marginBottom: '1.5rem' }}>
                Any technical data, such as IP addresses or browser information, may be logged by our hosting provider 
                for <strong style={{ color: '#E8E8E8' }}>maintenance and security purposes</strong> only. However, no personally 
                identifiable information is collected or shared by ST Motors.
              </p>

              <h2 style={{
                fontSize: 'clamp(1.3rem, 2.5vw, 1.6rem)',
                fontWeight: '500',
                color: '#C7B381',
                marginTop: 'clamp(2rem, 4vw, 3rem)',
                marginBottom: '1rem',
                letterSpacing: '0.02em'
              }}>
                Contact Us
              </h2>
              <p style={{ marginBottom: '1.5rem' }}>
                For questions about this privacy policy, please contact us at:
              </p>
              
              <div style={{
                background: 'rgba(199, 179, 129, 0.1)',
                border: '1px solid rgba(199, 179, 129, 0.2)',
                borderRadius: '12px',
                padding: 'clamp(1.5rem, 3vw, 2rem)',
                marginTop: '2rem'
              }}>
                <div style={{ 
                  display: 'flex', 
                  flexDirection: isMobile ? 'column' : 'row',
                  gap: 'clamp(1rem, 2vw, 2rem)',
                  alignItems: isMobile ? 'flex-start' : 'center'
                }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ 
                      fontSize: 'clamp(0.75rem, 1.5vw, 0.85rem)', 
                      color: '#808080', 
                      textTransform: 'uppercase', 
                      letterSpacing: '0.05em',
                      marginBottom: '0.5rem'
                    }}>
                      Email
                    </div>
                    <a 
                      href="mailto:marketting@sangaytsheltrim.com" 
                      style={{
                        color: '#C7B381',
                        textDecoration: 'none',
                        fontSize: 'clamp(0.95rem, 1.8vw, 1.05rem)',
                        fontWeight: '500',
                        transition: 'color 0.3s ease'
                      }}
                      onMouseEnter={(e) => e.target.style.color = '#E8D4A0'}
                      onMouseLeave={(e) => e.target.style.color = '#C7B381'}
                    >
                      marketting@sangaytsheltrim.com
                    </a>
                  </div>
                  
                  <div style={{ flex: 1 }}>
                    <div style={{ 
                      fontSize: 'clamp(0.75rem, 1.5vw, 0.85rem)', 
                      color: '#808080', 
                      textTransform: 'uppercase', 
                      letterSpacing: '0.05em',
                      marginBottom: '0.5rem'
                    }}>
                      Phone
                    </div>
                    <a 
                      href="tel:+97577248888" 
                      style={{
                        color: '#C7B381',
                        textDecoration: 'none',
                        fontSize: 'clamp(0.95rem, 1.8vw, 1.05rem)',
                        fontWeight: '500',
                        transition: 'color 0.3s ease'
                      }}
                      onMouseEnter={(e) => e.target.style.color = '#E8D4A0'}
                      onMouseLeave={(e) => e.target.style.color = '#C7B381'}
                    >
                      +975 77248888
                    </a>
                  </div>
                </div>
              </div>

              <p style={{ 
                marginTop: 'clamp(2rem, 4vw, 3rem)', 
                fontSize: 'clamp(0.85rem, 1.7vw, 0.95rem)',
                color: '#808080',
                fontStyle: 'italic'
              }}>
                Last updated: February 2026
              </p>
            </div>
          </div>

          {/* Additional Links */}
          <div style={{
            marginTop: 'clamp(2rem, 4vw, 3rem)',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
            gap: 'clamp(1.5rem, 3vw, 2rem)',
            flexWrap: 'wrap'
          }}>
            <Link
              to="/terms-of-service"
              style={{
                color: '#B8B8B8',
                textDecoration: 'none',
                fontSize: 'clamp(0.85rem, 1.7vw, 0.95rem)',
                fontWeight: '400',
                transition: 'color 0.3s ease',
                borderBottom: '1px solid transparent'
              }}
              onMouseEnter={(e) => {
                e.target.style.color = '#C7B381';
                e.target.style.borderBottomColor = '#C7B381';
              }}
              onMouseLeave={(e) => {
                e.target.style.color = '#B8B8B8';
                e.target.style.borderBottomColor = 'transparent';
              }}
            >
              Terms of Service →
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}

export default PrivacyPolicy;